export const INVALID_EXTENSIONS = ["dmg", "exe"];

const convertBytesToMb = (number: number) => number / 1024 ** 2;

export const calculateFileListSize = (fileList: File[]) =>
  fileList
    .reduce((acc: Array<number>, curr) => {
      acc.push(convertBytesToMb(curr.size));
      return acc;
    }, [])
    .reduce((a, b) => a + b, 0);

export const hasInvalidExtensions = (fileList: File[]) =>
  fileList
    .reduce((acc: Array<string>, curr) => {
      const extension = curr.name.split(".").pop();

      if (extension) {
        acc.push(extension);
      }
      return acc;
    }, [])
    .some((element: string) => INVALID_EXTENSIONS.includes(element));
